import Table from '@tiptap/extension-table';

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      customStyle: {
        default: null,
        renderHTML: () => {
          return {
            style:
              'border-collapse: collapse; table-layout: auto;  width: max-content;margin: 0; white-space: normal; word-break: break-word;',
          };
        },
      },
    };
  },
}).configure({
  resizable: true,
});
